// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect, useState } from "react";
import { models, Report, Embed, service } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import "powerbi-report-authoring";
import "./CustomReportsPage.scss";
import { useHistory } from "react-router-dom";

import {
  getReportsByIdUrl,
  getPowerBiTokenByUrl,
} from "../../../helpers/RestApisHelper/RestApis";
import { useParams } from "react-router";
import { fetchUser } from "../../../components/LandingPage/functions/fetchUser";
import { Button, Modal, Typography } from "ae-ui-components";
import _ from "lodash";
import axios from "axios";

// Root Component to demonstrate usage of wrapper component
const CustomReportsPage = () => {
  // PowerBI Report object (to be received via callback)
  const { Title, Caption } = Typography;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [report, setReport] = useState<Report>();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [currReport, setCurrReport] = useState<{
    reportName: string;
    reportId: string;
    description: string;
    imgUrl: string;
    id: number;
    product?: string;
    createdOn?: string;
  }>();
  const history = useHistory();
  const { reportId }: { reportId: string } = useParams();
  const [groupId, setGroupId] = useState<string>("");
  console.log({ currReport });
  // API end-point url to get embed config for a sample report
  // const sampleReportUrl =
  //   "https://playgroundbe-bck-1.azurewebsites.net/Reports/SampleReport";

  // Report config useState hook
  // Values for properties like embedUrl, accessToken and settings will be set on click of buttons below

  const [sampleReportConfig, setReportConfig] =
    useState<models.IReportEmbedConfiguration>({
      type: "report",
      embedUrl: "",
      tokenType: models.TokenType.Embed,
      accessToken: "",
      id: "",
      settings: {
        navContentPaneEnabled: false,
        panes: {
          filters: {
            expanded: false,
            visible: false,
          },
        },
      },
      // eventHooks: {
      //   accessTokenProvider: getNewAccessToken,
      // },
    });
  const handleOpenDescription = () => {
    setIsOpenModal(true);
  };

  useEffect(() => {
    if (!reportId) return;
    const url = getReportsByIdUrl;
    const id = reportId;
    if (id) {
      fetchUser(url, JSON.stringify({ id: id.trim() }))
        .then((currReport) => {
          const { data } = currReport;
          setGroupId(data?.embedUrl);
          setCurrReport({ ...data, product: data.product.displayName });

          const temp = new URLSearchParams(data.embedUrl);
          temp.set("reportId", data.reportId);
          console.log({ temp: temp.toString() });
          console.log({ data });
        })
        .catch((error) => {
          if (error) {
            console.log({ error });
          }
        });
    }
  }, [reportId]);

  useEffect(() => {
    if (!currReport || !groupId) return;
    const data = {
      groupId,
      reportId: currReport?.reportId,
    };
    axios
      .post(getPowerBiTokenByUrl, data)
      .then((res: any) => {
        console.log("response", res);
        const powerBiData = res?.data?.data;
        setReportConfig((prev) => {
          return {
            ...prev,
            accessToken: powerBiData?.finalToken,
            id: powerBiData?.id,
            embedUrl: powerBiData?.embedUrl,

            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
              },
            },
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [currReport, groupId]);

  // Map of event handlers to be applied to the embedding report
  const eventHandlersMap = new Map([
    [
      "loaded",
      function () {
        console.log("Report has loaded");
      },
    ],
    [
      "rendered",
      function () {
        console.log("Report has rendered");

        // Update display message
        // setMessage("The report is rendered");
      },
    ],
    [
      "error",
      function (event?: service.ICustomEvent<any>) {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
  ]);

  // const changeSettings = () => {
  //   // Update the state "sampleReportConfig" and re-render DemoApp component
  //   setReportConfig({
  //     ...sampleReportConfig,
  //     settings: {
  //       panes: {
  //         filters: {
  //           expanded: false,
  //           visible: false,
  //         },
  //       },
  //     },
  //   });
  // };

  // Delete the first visual using powerbi-report-authoring library
  // const deleteVisual = async () => {
  //   if (!report) {
  //     console.log("Report not available");
  //     return;
  //   }

  //   const activePage = await getActivePage(report);

  //   if (!activePage) {
  //     console.log("No active page");
  //     return;
  //   }

  //   // Get all visuals in the active page
  //   const visuals = await activePage.getVisuals();

  //   if (visuals.length === 0) {
  //     console.log("No visual left");
  //     return;
  //   }

  //   async function getActivePage(
  //     powerbiReport: Report
  //   ): Promise<Page | undefined> {
  //     const pages = await powerbiReport.getPages();

  //     // Get the active page
  //     const activePage = pages.filter(function (page) {
  //       return page.isActive;
  //     })[0];

  // async function getActivePage(
  //   powerbiReport: Report
  // ): Promise<Page | undefined> {
  //   const pages = await powerbiReport.getPages();

  //   // Get the active page
  //   const activePage = pages.filter(function (page) {
  //     return page.isActive;
  //   })[0];

  //   return activePage;
  // }

  return (
    <div className="custom-reports-container">
      <Modal
        title="Description"
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
      >
        <div className="custom-report-description">
          {currReport?.description || ""}
        </div>
      </Modal>
      <div className="custom-reports-container-top">
        <div className="products-list-container-header">
          {!!currReport ? (
            <div>
              <Title level={3}>{_.capitalize(currReport.reportName)}</Title>
              <Caption>
                Product: {currReport.product ? currReport.product : "DDE"}
              </Caption>
              <div>
                <Button onClick={() => handleOpenDescription()} type="link">
                  Description
                </Button>
              </div>
            </div>
          ) : null}

          <div>
            <Button
              className="default-button-class"
              style={{ width: "90px", height: "36px" }}
              onClick={() => history.push("/reports")}
            >
              Back
            </Button>
          </div>
        </div>
      </div>
      <div className="custom-reports-container-bottom flex items-center justify-center">
        <PowerBIEmbed
          embedConfig={sampleReportConfig}
          eventHandlers={eventHandlersMap}
          cssClassName={"custom-report"}
          getEmbeddedComponent={(embedObject: Embed) => {
            console.log(
              `Embedded object of type "${embedObject.embedtype}" received`
            );
            setReport(embedObject as Report);
          }}
        />
      </div>
    </div>
  );
};

export default CustomReportsPage;
